// extracted by mini-css-extract-plugin
module.exports = {"icongray":"#d5d5d9","iconblue":"#2a4284","fontsizepx":"20px"};